import { RadioGroup } from "@headlessui/react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getAllOwnersFromParties } from "js/utilities";
import {
  getPolicyType,
  getName,
  stringFormattingToCurrency,
  getBadgeText,
} from "js/formatting";

const DeprecatedPanelOne = ({
  panelOneSelection,
  setPanelTwoSelection,
  setPanelOneSelection,
  dataArray,
  register,
  setCurrentStep,
  handleSubmit,
  dataSubmit,
  setValue,
  setSelectedPolicy,
  setIsDisabled,
  setStepTwoChecked,
}) => {
  const { user } = useSelector((state) => state.user);
  const [primaryOwnerName, setPrimaryOwnerName] = useState();

  const mainPolicy = dataArray[0];
  useEffect(() => {
    let parties = getAllOwnersFromParties(mainPolicy?.parties);
    let primaryOwner = parties?.find(
      (x) => x.person?.taxId === user.identityNumber
    );
    if (primaryOwner)
      setPrimaryOwnerName(() => {
        return getName(primaryOwner?.person);
      });
  }, [user, dataArray]);

  const [plan, setPlan] = useState("");

  const [buttonOneChecked, setButtonOneChecked] = useState(false);
  const [buttonTwoChecked, setButtonTwoChecked] = useState(true);

  const onButtonOneClick = () => {
    setValue("policy", mainPolicy?.contractID);
    handleSubmit(dataSubmit)();
  };

  const onButtonTwoClick = () => {
    if (panelOneSelection) {
      setValue("policy", panelOneSelection);
      handleSubmit(dataSubmit)();
    }
  };
  useEffect(() => {
    if (buttonOneChecked) {
      onButtonOneClick();
      setCurrentStep(2);
    }
    if (buttonTwoChecked) {
      onButtonTwoClick();
      setCurrentStep(2);
    }
  }, [
    panelOneSelection,
    panelOneSelection,
    buttonOneChecked,
    buttonTwoChecked,
  ]);

  return (
    <div className="px-0 md:px-16">
      <form>
        <RadioGroup
          className="ui-form-card-row"
          value={plan}
          onChange={setPlan}
        >
          {mainPolicy && (
            <RadioGroup.Option
              id="ID_paymentStep1Option1"
              className={({ checked }) =>
                `${
                  checked && buttonOneChecked
                    ? "ui-form-card selected"
                    : "ui-form-card"
                }`
              }
              tabIndex="0"
              aria-label="Select to pay this policy"
              aria-controls="ID_paymentStep2Options"
              aria-expanded="false"
              value={mainPolicy?.contractID}
              {...register("policy")}
              onClick={() => {
                setPanelOneSelection(mainPolicy);
                setButtonTwoChecked(false);
                setButtonOneChecked(true);
              }}
            >
              {({ checked }) => (
                <>
                  <RadioGroup.Label
                    className="block text-xxs text-ui-gray-default pr-8 cursor-pointer font-semibold"
                    as="div"
                  >
                    Policy # {mainPolicy?.oldPolicy}
                  </RadioGroup.Label>
                  <RadioGroup.Label
                    className="block text-black group-hover:underline"
                    as="div"
                  >
                    {" "}
                    {mainPolicy?.policyType}{" "}
                    {mainPolicy ? `${getPolicyType(mainPolicy)} - ` : ""}
                    {primaryOwnerName}
                    {/* {mainPolicy.policyTitle} */}
                  </RadioGroup.Label>

                  <RadioGroup.Label className="flex items-center text-xxs">
                    {getBadgeText(mainPolicy).includes("Past Due") && (
                      <svg
                        className="ui-icon w-4 h-4 text-ui-red mr-2"
                        focusable="false"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <use href="#ui-icon-circle-close"></use>
                      </svg>
                    )}
                    {getBadgeText(mainPolicy).includes("Past Due") ? (
                      ""
                    ) : (
                      <>
                        {mainPolicy?.modalPremiumAmountTotal
                          ? stringFormattingToCurrency(
                              mainPolicy?.modalPremiumAmountTotal
                            )
                          : "0.00"}{" "}
                      </>
                    )}
                    {getBadgeText(mainPolicy)}
                  </RadioGroup.Label>
                  <div className="text-xxs font-semibold pr-8 group-hover:underline">
                    <div className="ui-form-card-checkbox">
                      <svg
                        className="ui-icon w-2 h-2 text-white hidden"
                        focusable="false"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <use href="#ui-icon-checkmark"></use>
                      </svg>
                    </div>
                  </div>
                </>
              )}
            </RadioGroup.Option>
          )}

          <RadioGroup.Option
            id="ID_paymentStep1Option1"
            className={({ checked }) =>
              `${buttonTwoChecked ? "ui-form-card selected" : "ui-form-card"}  `
            }
            tabIndex="0"
            aria-label="Select to pay this policy"
            aria-controls="ID_paymentStep2Options"
            aria-expanded="false"
          >
            {({ checked }) => (
              <>
                <RadioGroup.Label as="div">
                  <div
                    id="ID_paymentStep1Option2"
                    className="group xl:basis-1/2"
                    tabIndex="0"
                    aria-label="Enable ability to choose another policy"
                  >
                    <div className="ui-form-card-checkbox">
                      <svg
                        className="ui-icon w-2 h-2 text-white hidden"
                        focusable="false"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <use href="#ui-icon-checkmark"></use>
                      </svg>
                    </div>

                    <div className="text-xxs font-semibold pr-8 group-hover:underline mb-1">
                      Another Policy
                    </div>

                    <select
                      id="ID_selectPolicy"
                      name="policy"
                      className="text-sm"
                      {...register("policy")}
                      value={panelOneSelection}
                      aria-label="Select policy to pay"
                      aria-controls="ID_paymentStep2Options"
                      aria-expanded="false"
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        setButtonOneChecked(false);
                        setButtonTwoChecked(true);
                        setPanelOneSelection(e.target.value);
                        setPanelTwoSelection("");
                        let policy = dataArray?.find(
                          (p) => p.contractID === e.target.value
                        );
                        setSelectedPolicy(policy);
                        setIsDisabled(true);
                        setStepTwoChecked(undefined);
                      }}
                    >
                      <option>Please select a policy</option>
                      {dataArray.map((item, idx) => (
                        <option value={item.contractID} key={idx}>
                          {primaryOwnerName} - {item?.oldPolicy}
                        </option>
                      ))}
                    </select>
                  </div>
                </RadioGroup.Label>
              </>
            )}
          </RadioGroup.Option>
        </RadioGroup>
      </form>
    </div>
  );
};

export default DeprecatedPanelOne;
